export const userEvents = {
    PASSWORD_UPDATED: "PASSWORD_UPDATED",
    PASSWORD_CHANGED_BY_OTHER_USER: "PASSWORD_CHANGED_BY_OTHER_USER",
}